import { render, staticRenderFns } from "./TableSkeleton.vue?vue&type=template&id=b16a57ac&scoped=true"
import script from "./TableSkeleton.vue?vue&type=script&lang=js"
export * from "./TableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TableSkeleton.vue?vue&type=style&index=0&id=b16a57ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16a57ac",
  null
  
)

export default component.exports